import { motion } from 'framer-motion';
import { ArrowUpRight } from 'lucide-react';
import { SERVICES } from './data';

export const Services = () => {
  const go = () => document.querySelector('#contacto')?.scrollIntoView({ behavior: 'smooth' });

  return (
    <section id="servicios" data-testid="services-section" className="py-20 sm:py-32 border-t border-white/10">
      <div className="mx-auto max-w-7xl px-5 sm:px-8">
        <div className="mb-12 flex flex-col sm:flex-row sm:items-end sm:justify-between gap-6">
          <div>
            <p className="text-acid uppercase tracking-[0.3em] text-xs mb-4">Qué pincho</p>
            <h2 className="font-heading uppercase text-4xl sm:text-6xl tracking-tight text-[#f1f0ea]">
              Tipos de <span className="text-acid">evento</span>
            </h2>
          </div>
          <p className="text-[#f1f0ea]/70 font-light max-w-md">
            Cada evento tiene su energía. Adapto la sesión al formato sin renunciar al criterio.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-12 gap-5">
          {SERVICES.map((s, i) => (
            <motion.button
              key={s.id}
              data-testid={`service-card-${s.id}`}
              onClick={go}
              initial={{ opacity: 0, y: 40 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.5, delay: i * 0.1 }}
              className={`group relative overflow-hidden border border-white/10 text-left min-h-[300px] sm:min-h-[360px] hover:border-acid transition-colors duration-300 ${s.span}`}
            >
              <img
                src={s.image}
                alt={s.title}
                loading="lazy"
                className="absolute inset-0 w-full h-full object-cover opacity-40 saturate-[0.7] group-hover:opacity-55 group-hover:scale-105 transition-all duration-500"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-ink via-ink/60 to-transparent" />
              <div className="relative z-10 h-full flex flex-col justify-between p-6 sm:p-8">
                <span className="font-heading text-acid text-xl">{s.tag}</span>
                <div>
                  <h3 className="font-heading uppercase text-3xl sm:text-4xl text-[#f1f0ea] leading-none flex items-center gap-2">
                    {s.title}
                    <ArrowUpRight className="text-acid opacity-0 group-hover:opacity-100 -translate-x-2 group-hover:translate-x-0 transition-all duration-300" />
                  </h3>
                  <p className="mt-4 text-[#f1f0ea]/75 font-light max-w-xl">{s.desc}</p>
                </div>
              </div>
            </motion.button>
          ))}
        </div>
      </div>
    </section>
  );
};
